import React from 'react'
import styled from 'styled-components'

export default styled.section`
  margin: 2rem 1rem;
  padding: 1rem 2rem;
  background: white;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1), 8px 8px 20px rgba(0, 0, 0, 0.05);
  flex: 1;

  &:first-child {
    margin-left: 2rem;
  }

  &:last-child {
    margin-right: 2rem;
  }

  @media (max-width: 960px) {
    margin: 2rem 2rem 0 2rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/section.js